export const DATE_FORMATS = {
    s: 'MM/DD/YYYY HH:mm:ss',
    m: 'MM/DD/YYYY HH:mm',
    H: 'MM/DD/YYYY HH',
    D: 'MM/DD/YYYY',
    M: 'MM/YYYY',
    W: 'YYYY-wo',
    Q: 'YYYY-[Q]Q',
    Y: 'YYYY',
    HH: 'HH',
    Hm: 'HH:mm',
    Hms: 'HH:mm:ss',
};
export const NUMBER_COMPACT = [
    {
        compact: 'K',
        conversion: 1000,
    },
    {
        compact: 'M',
        conversion: 1000000,
    },
    {
        compact: 'B',
        conversion: 1000000000,
    },
    {
        compact: 'T',
        conversion: 1000000000000,
    },
];
